import "./style.scss";
import { FC, useEffect, useState } from "react";
import { AOPUkraineRequestData } from "@/src/types/admissionOffice";
import backForDocUkraineWithPrint from "@/src/assets/admissionOfficePage/back-for-doc-ukraine-with-print.webp";
import backForDocUkraineWithOutPrint from "@/src/assets/admissionOfficePage/back-for-doc-ukraine-without-print.webp";
import type { RequestLetterBasicCountry } from "../requestLetterBasicRegistry";

interface AOPPrevProps {
  country: RequestLetterBasicCountry;
  bodyForPrev: AOPUkraineRequestData;
}

const AOPPrev: FC<AOPPrevProps> = ({ country, bodyForPrev }) => {
  const [actualBg, setActualBg] = useState(backForDocUkraineWithOutPrint);

  useEffect(() => {
    setActualBg(bodyForPrev.withPrint ? backForDocUkraineWithPrint : backForDocUkraineWithOutPrint);
  }, [bodyForPrev.withPrint]);

  return (
    <div className="admission-office-prev-wrapper">
      <div className={`admission-office-prev ${country} request`}>
        <img className="admission-office-prev-background" src={actualBg} alt="" />
        <div className="admission-office-prev-section number-and-date">
          <span>№ </span>
          <span>від {bodyForPrev.currentDate ? bodyForPrev.currentDate : "-"}</span>
        </div>
        <div className="admission-office-prev-section title">
          <p>ДОВІДКА ЗА ВИМОГОЮ</p>
        </div>
        {bodyForPrev.bodyPV ? (
          <div className="admission-office-prev-section body-content">
            {bodyForPrev.bodyPV.map((item, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
        ) : null}
      </div>
      {bodyForPrev.secondBody && bodyForPrev.secondBody.length > 0 ? (
        <div className={`admission-office-prev ${country} request`}>
          <img className="admission-office-prev-background" src={actualBg} alt="" />
          <div className="admission-office-prev-section number-and-date">
            <span>№ </span>
            <span>від {bodyForPrev.currentDate ? bodyForPrev.currentDate : "-"}</span>
          </div>
          <div className="admission-office-prev-section title">
            <p>ДОВІДКА ЗА ВИМОГОЮ</p>
          </div>
          <div className="admission-office-prev-section body-content">
            {bodyForPrev.secondBody.map((item, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default AOPPrev;
